import * as addSmsTemplate from '../services/addSmsTemplate';

export default {
  namespace: 'addSmsTemplate',

  state: {
    isAddSuccess: null,
    signatureList: [],
  },

  effects: {
    *handleAddTempMsg({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addSmsTemplate.handleAddTempMsg, values);
      yield put({
        type: 'save',
        payload: {
          isAddSuccess: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *handleUpdateTempMsg({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addSmsTemplate.handleUpdateTempMsg, values);
      yield put({
        type: 'save',
        payload: {
          isAddSuccess: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getSignatureList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addSmsTemplate.getSignatureList, values);
      yield put({
        type: 'save',
        payload: {
          signatureList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *postPreview({ payload: { values }, callback }, { call }) {
      const response = yield call(addSmsTemplate.postPreview, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //查询短信模板消息变量定义列表
    *getQueryTempMsgVariableList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addSmsTemplate.getQueryTempMsgVariableList, values);
      yield put({
        type: 'save',
        payload: {
          tempMsgVariableList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
